import { useExitFeeFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';

import type { TProduct } from 'api/models/TProduct';

export const useExitFeeValue = (product: TProduct = {} as TProduct) => {
  const [exitFeeValue, exitFeeDetails] = useExitFeeFeatures(product);

  const full = (
    <>
      {exitFeeValue?.description}
      <br />
      {exitFeeDetails?.description}
    </>
  );

  return {
    short: exitFeeValue?.description,
    details: exitFeeDetails?.description,
    full
  };
};
